import { ErrorBoundary } from '@/pages/user-profile/user-profile.error';

export default ErrorBoundary;
